import React from 'react';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const current = { level: 'SDE-1 · mid-tier product', ctc: 18 };
const next = { level: 'SDE-2 · top-tier product', ctc: 50 };
const hike = Math.round(((next.ctc - current.ctc) / current.ctc) * 100);

const skills = ['Advanced DSA', 'HLD & LLD', 'Ownership at scale'];

const HeroHikeCard = () => (
  <div className="hike-card">
    <span className="hero-card-pill">
      <TrendingUpIcon sx={{ fontSize: 16 }} />
      Low-paying to top-paying product company
    </span>

    <div className="hike-offers">
      <div className="hike-offer">
        <div className="hike-offer-head">
          <span>Current</span>
          <strong>₹{current.ctc} LPA</strong>
        </div>
        <div className="hike-bar">
          <span style={{ '--w': `${(current.ctc / next.ctc) * 100}%` }} />
        </div>
        <small>{current.level}</small>
      </div>

      <div className="hike-offer hike-offer--next">
        <div className="hike-offer-head">
          <span>Next offer</span>
          <strong>₹{next.ctc} LPA</strong>
        </div>
        <div className="hike-bar">
          <span style={{ '--w': '100%' }} />
        </div>
        <small>{next.level}</small>
        <span className="hike-badge">+{hike}% hike</span>
      </div>
    </div>

    <div className="hero-card-skills">
      <span>What top-tier interviews test</span>
      <ul>
        {skills.map((s, i) => <li key={s} style={{ '--i': i }}>{s}</li>)}
      </ul>
    </div>
  </div>
);

export default HeroHikeCard;
